/* eslint-disable react/display-name */
import React from 'react'
import ArtistReunionLayout from './ArtistReunionLayout'
import BackOfficeTrainingLayout from './BackOfficeTrainingLayout'
import CompensationPlanLayout from './CompensationPlanLayout'
import DemiColourLayout from './DemiColourLayout'
import EventsLayout from './EventsLayout'
import HeadquartersLayout from './HeadquartersLayout'
import IncentiveTripLayout from './IncentiveTripLayout'
import InventoryLayout from './InventoryLayout'
import Layout from './Layout'
import LeadershipRetreatLayout from './LeadershipRetreatLayout'
import NewsLayout from './NewsLayout'
// import ResourcesLayout from './ResourcesLayout'
import RecognitionLayout from './RecognitionLayout'
import SugarLayout from './SugarLayout'
import SupportLayout from './SupportLayout'
import TrainingLayout from './TrainingLayout'

// @ts-ignore
export default ({ location, children, pageContext }) => {
  if (pageContext.layout === 'news') {
    return (
      <NewsLayout pageName="News" location={location}>
        {children}
      </NewsLayout>
    )
  }
  if (pageContext.layout === 'incentive-trip') {
    return (
      <IncentiveTripLayout pageName="Incentive Trip" location={location}>
        {children}
      </IncentiveTripLayout>
    )
  }
  if (pageContext.layout === 'artist-reunion') {
    return (
      <ArtistReunionLayout pageName="Artist Reunion" location={location}>
        {children}
      </ArtistReunionLayout>
    )
  }
  if (pageContext.layout === 'leadership-retreat') {
    return (
      <LeadershipRetreatLayout
        pageName="Leadership Retreat"
        location={location}
      >
        {children}
      </LeadershipRetreatLayout>
    )
  }
  if (pageContext.layout === 'events') {
    return (
      <EventsLayout pageName="Events" location={location}>
        {children}
      </EventsLayout>
    )
  }
  if (pageContext.layout === 'inventory') {
    return (
      <InventoryLayout pageName="Inventory" location={location}>
        {children}
      </InventoryLayout>
    )
  }
  if (pageContext.layout === 'training') {
    if (pageContext.subLayout === 'sugar') {
      return (
        <TrainingLayout pageName="Training" location={location}>
          <SugarLayout>{children}</SugarLayout>
        </TrainingLayout>
      )
    } else if (pageContext.subLayout === 'demi-colour') {
      return (
        <TrainingLayout pageName="Training" location={location}>
          <DemiColourLayout>{children}</DemiColourLayout>
        </TrainingLayout>
      )
    } else if (pageContext.subLayout === 'headquarters') {
      return (
        <TrainingLayout pageName="Training" location={location}>
          <HeadquartersLayout>{children}</HeadquartersLayout>
        </TrainingLayout>
      )
    } else if (pageContext.subLayout === 'back-office') {
      return (
        <TrainingLayout pageName="Training" location={location}>
          <BackOfficeTrainingLayout>{children}</BackOfficeTrainingLayout>
        </TrainingLayout>
      )
    } else if (pageContext.subLayout === 'compensation-plan') {
      return (
        <TrainingLayout pageName="Training" location={location}>
          <CompensationPlanLayout>{children}</CompensationPlanLayout>
        </TrainingLayout>
      )
    } else {
      return (
        <TrainingLayout pageName="Training" location={location}>
          {children}
        </TrainingLayout>
      )
    }
  }
  if (pageContext.layout === 'support') {
    return (
      <SupportLayout pageName="Support" location={location}>
        {children}
      </SupportLayout>
    )
  }
  if (pageContext.layout === 'recognition') {
    return (
      <RecognitionLayout pageName="Recognition" location={location}>
        {children}
      </RecognitionLayout>
    )
  }
  if (pageContext.layout === 'top-artist-profile') {
    return (
      <Layout pageName="Top Artist Profile" location={location}>
        {children}
      </Layout>
    )
  }
  if (pageContext.layout === 'article') {
    return (
      <Layout pageName="Article" location={location}>
        {children}
      </Layout>
    )
  }
  if (pageContext.layout === 'resources') {
    return (
      <Layout pageName="Resources" location={location}>
        {children}
      </Layout>
    )
  }
  if (pageContext.layout === 'home') {
    return (
      <Layout pageName="Home" location={location}>
        {children}
      </Layout>
    )
  } else {
    return <>{children}</>
  }
}
